export type ViewType = 'all' | 'instant' | 'products';
export type PriceFilterType = 'all' | 'priced' | 'unpriced';

export interface FilterState {
  // Direct filter values
  rarity: '' | 'set' | 'white' | 'magic' | 'rare' | 'unique' | 'runeword' | 'misc' | 'gem';
  type: string;
  itemType: string;
  newItems: '' | 'new-items-only' | 'no-new-items';
  ethereal: '' | 'eth' | 'non-eth';
  unidentified: '' | 'unid' | 'non-unid';
  limitFilter: number;
  viewType: 'all' | 'instant' | 'products';
  priceFilter: 'all' | 'priced' | 'unpriced';
  excludeStatFilters: StatFilter[];
  statFilterGroups: StatFilterGroup[];

  // UI State
  isFilterBubbleOpen: boolean;
  savedSearches: SavedSearch[];
  savedSearchSent: boolean;
  searchTerm: string;
  shouldApplySearch: boolean;
}

export interface SavedSearch {
  search_count: number;
  search_name: string;
  search_term: string;
}

export interface StatFilter {
  id: string;
  name: string;
  min: number;
  max: number;
}

export interface StatFilterGroup {
  id: string;
  filters: StatFilter[];
}

export interface Type {
  id: string;
  name: string;
  skin_path?: string;
}

export interface ItemType extends Type {
  // Inherits all properties from Type
}

export interface Category {
  id: string;
  name: string;
  skin_path?: string;
  code: string;
  types: Type[];
}

export interface Rarity {
  id: string;
  name: string;
}

export interface Stat {
  id: string;
  name: string;
}

export interface StaticData {
  types: Type[];
  categories: Category[];
  rarities: Rarity[];
  stats: Stat[];
  isLoading: {
    types: boolean;
    categories: boolean;
    rarities: boolean;
    stats: boolean;
  };
}

export const initialFilterState: FilterState = {
  rarity: '',
  type: '',
  itemType: '',
  newItems: '',
  ethereal: '',
  unidentified: '',
  limitFilter: 100,
  viewType: 'all',
  priceFilter: 'all',
  excludeStatFilters: [],
  statFilterGroups: [],
  isFilterBubbleOpen: false,
  savedSearches: [],
  savedSearchSent: false,
  searchTerm: '',
  shouldApplySearch: false,
};
